import { SITE_CONFIG } from '../../../config/site';

export const EMAIL_CONFIG = {
  admin: "admin@cantecelulmeu.ro",
  from: {
    orders: `${SITE_CONFIG.name} <comenzi@cantecelulmeu.ro>`,
    login: `${SITE_CONFIG.name} <login@cantecelulmeu.ro>`,
    contact: `${SITE_CONFIG.name} <contact@cantecelulmeu.ro>`,
    default: `${SITE_CONFIG.name} <noreply@cantecelulmeu.ro>`,
  },
  replyTo: 'contact@cantecelulmeu.ro',
} as const;